import { required, email as emailRule, sameAs } from 'vuelidate/lib/validators'

export const email = [
  {
    rule: required,
    msg: 'Email address is required'
  },
  {
    rule: emailRule,
    msg: 'Invalid email address'
  }
]

export const forgotEmail = [
  {
    rule: required,
    msg: 'Email address is required'
  },
  {
    rule: emailRule,
    msg: 'Invalid email address'
  }
]

export const forgotEmailConfirmation = [
  {
    rule: required,
    msg: 'Email address is required'
  },
  {
    rule: sameAs('forgotEmail'),
    msg: 'Email address does not match'
  }
]

export const password = [
  {
    rule: required,
    msg: 'Password is required'
  }
]

export const currentPassword = [
  {
    rule: required,
    msg: 'Password is required'
  }
]

export const confirmPassword = [
  {
    rule: required,
    msg: 'Password is required'
  },
  {
    rule: sameAs('password'),
    msg: 'Passwords do not match'
  }
]

export const signupPassword = [
  {
    rule: required,
    msg: 'Password is required'
  }
]

export const passwordConfirmation = [
  {
    rule: required,
    msg: 'Password is required'
  },
  {
    rule: sameAs('signupPassword'),
    msg: 'Passwords do not match'
  }
]

export const resetPassword = [
  {
    rule: required,
    msg: 'Password is required'
  }
]

export const resetPasswordConfirmation = [
  {
    rule: required,
    msg: 'Password is required'
  },
  {
    rule: sameAs('resetPassword'),
    msg: 'Passwords do not match'
  }
]

export const firstName = [
  {
    rule: required,
    msg: 'First name is required'
  }
]

export const lastName = [
  {
    rule: required,
    msg: 'Last name is required'
  }
]

export const organization = [
  {
    rule: required,
    msg: 'Organization is required'
  }
]

export const organizationDescription = [
  {
    rule: required,
    msg: 'Organization description is required'
  }
]

export const name = [
  {
    rule: required,
    msg: 'Name is required'
  }
]

export const description = [
  {
    rule: required,
    msg: 'Description is required'
  }
]

export const configRules = [
  {
    rule: required,
    msg: 'Rules is required'
  },
  {
    async rule (value) {
      if (value === '') return false
      const response = await this.$store.dispatch('validateGNIPRule', value)
      const data = await response.data
      if (data.status !== 'SUCCESS' || !data.payload) {
        return false
      }
      return Boolean(await data.payload)
    },
    msg: 'GNIP Rule is not valid.'
  }
]

export const configNewsapi = [
  {
    rule: required,
    msg: 'News API is required'
  }
]

export const configDatabaseName = [
  {
    rule: required,
    msg: 'Database name is required'
  }
]

const vrules = (vdata) => {
  return vdata.reduce((acc, cur, i) => {
    acc[i] = cur.rule
    return acc
  }, {})
}

const vmsg = (validator, vdata) => {
  for (let i = 0; i < vdata.length; i++) {
    if (!validator[i]) { return vdata[i].msg }
  }
}

export default {
  vrules,
  vmsg
}



// WEBPACK FOOTER //
// ./src/helpers/validators.js